module.exports = __webpack_public_path__ + "img/venus12.e0923163.png";